import { request } from '@umijs/max';
import {
  ActionResultData,
  BatchDeleteBody9,
  BatchDisablePayload8,
  BatchEnableBody15,
  BatchHiddenBody12,
  BatchSetOrderPayload8,
  BatchShowBody10,
  PagerDataSysOrg,
  PathsPayload,
  SaveTagsPayload5,
  SetOrderBody9,
  SysOrg,
  SysOrgNode,
  SysOrgRequest,
  SysPost,
  TagInfo,
  TreeNode,
  UploadVo,
} from '../AdminTypings';

export namespace AdminSysOrg {
  /**
   * @summary 组织树-系统
   * @secure
   */
  export const treeSys = async (data: SysOrgRequest, params: { [key: string]: any } = {}) => {
    return request<SysOrg[]>(`/admin/sys/org/tree/sys`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 组织机构树
   * @secure
   */
  export const treeQuery = async (data: SysOrgRequest, params: { [key: string]: any } = {}) => {
    return request<SysOrg[]>(`/admin/sys/org/tree/query`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 部门树
   * @secure
   */
  export const treeDepartment = async (
    data: SysOrgRequest,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysOrg[]>(`/admin/sys/org/tree/department`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 直属库树
   * @secure
   */
  export const treeChild = async (data: SysOrgRequest, params: { [key: string]: any } = {}) => {
    return request<SysOrg[]>(`/admin/sys/org/tree/child`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 保存数据标签
   * @secure
   */
  export const saveTags = async (
    id: number,
    data: SaveTagsPayload5,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/org/tag/save/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 设置排序权重
   * @secure
   */
  export const setOrder = async (
    pid: number,
    id: number,
    data: SetOrderBody9,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/org/set/order/${pid}/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 查询列表
   * @secure
   */
  export const query = async (
    pid: number,
    data: SysOrgRequest,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysOrg[]>(`/admin/sys/org/query/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 查询列表
   * @secure
   */
  export const queryChild = async (
    pid: number,
    data: SysOrgRequest,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysOrg[]>(`/admin/sys/org/query/child/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 组织路径
   * @secure
   */
  export const paths = async (data: PathsPayload, params: { [key: string]: any } = {}) => {
    return request<number[][]>(`/admin/sys/org/paths`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 分页列表
   * @secure
   */
  export const list = async (
    pid: number,
    data: SysOrgRequest,
    params: { [key: string]: any } = {},
  ) => {
    return request<PagerDataSysOrg>(`/admin/sys/org/list/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 配置岗位
   * @secure
   */
  export const getPosts = async (orgId: number, params: { [key: string]: any } = {}) => {
    return request<SysPost[]>(`/admin/sys/org/get/posts/${orgId}`, {
      method: 'POST',
      ...params,
    });
  };

  /**
   * @summary 组织用户
   * @secure
   */
  export const getMembersAccounts = async (orgId: number, params: { [key: string]: any } = {}) => {
    return request<Record<string, number>>(`/admin/sys/org/get/members/accounts/${orgId}`, {
      method: 'POST',
      ...params,
    });
  };

  /**
   * @summary 编辑组织
   * @secure
   */
  export const edit = async (
    pid: number,
    id: number,
    data: SysOrg,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/org/edit/${pid}/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 新建组织
   * @secure
   */
  export const create = async (pid: number, data: SysOrg, params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/org/create/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量显示
   * @secure
   */
  export const batchShow = async (
    pid: number,
    data: BatchShowBody10,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/org/batch/show/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量设置排序权重
   * @secure
   */
  export const batchSetOrder = async (
    pid: number,
    data: BatchSetOrderPayload8,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/org/batch/set/order/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量隐藏
   * @secure
   */
  export const batchHidden = async (
    pid: number,
    data: BatchHiddenBody12,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/org/batch/hidden/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量启用
   * @secure
   */
  export const batchEnable = async (
    pid: number,
    data: BatchEnableBody15,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/org/batch/enable/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量禁用
   * @secure
   */
  export const batchDisable = async (
    pid: number,
    data: BatchDisablePayload8,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/org/batch/disable/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量删除
   * @secure
   */
  export const batchDelete = async (
    pid: number,
    data: BatchDeleteBody9,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/org/batch/delete/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 组织树-UI
   * @secure
   */
  export const treeUi = async (params: { [key: string]: any } = {}) => {
    return request<TreeNode[]>(`/admin/sys/org/tree/ui`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 组织机构树 [NODE]
   * @secure
   */
  export const treeNodeQuery = async (params: { [key: string]: any } = {}) => {
    return request<SysOrgNode[]>(`/admin/sys/org/tree/node/query`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 部门树 [NODE]
   * @secure
   */
  export const treeNodeDepartment = async (params: { [key: string]: any } = {}) => {
    return request<SysOrgNode[]>(`/admin/sys/org/tree/node/department`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 直属库树 [NODE]
   * @secure
   */
  export const treeNodeChild = async (params: { [key: string]: any } = {}) => {
    return request<SysOrgNode[]>(`/admin/sys/org/tree/node/child`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取数据可用标签
   * @secure
   */
  export const getTagList = async (id: number, params: { [key: string]: any } = {}) => {
    return request<TagInfo[]>(`/admin/sys/org/tag/list/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取数据标签
   * @secure
   */
  export const getTags = async (id: number, params: { [key: string]: any } = {}) => {
    return request<string[]>(`/admin/sys/org/tag/get/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 静态 tree
   * @secure
   */
  export const staticTree = async (params: { [key: string]: any } = {}) => {
    return request<UploadVo>(`/admin/sys/org/static/tree`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 静态 部门树
   * @secure
   */
  export const staticDepartment = async (params: { [key: string]: any } = {}) => {
    return request<UploadVo>(`/admin/sys/org/static/department`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 静态 直属库树
   * @secure
   */
  export const staticChild = async (params: { [key: string]: any } = {}) => {
    return request<UploadVo>(`/admin/sys/org/static/child`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 显示
   * @secure
   */
  export const show = async (pid: number, id: number, params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/org/show/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 组织路径
   * @secure
   */
  export const path = async (id: number, params: { [key: string]: any } = {}) => {
    return request<number[]>(`/admin/sys/org/path/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 组织路径详情
   * @secure
   */
  export const pathInfo = async (id: number, params: { [key: string]: any } = {}) => {
    return request<SysOrg[]>(`/admin/sys/org/path/info/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 隐藏
   * @secure
   */
  export const hidden = async (pid: number, id: number, params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/org/hidden/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 启用
   * @secure
   */
  export const enable = async (pid: number, id: number, params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/org/enable/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 禁用
   * @secure
   */
  export const disable = async (pid: number, id: number, params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/org/disable/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 详情
   * @secure
   */
  export const detail = async (pid: number, id: number, params: { [key: string]: any } = {}) => {
    return request<SysOrg>(`/admin/sys/org/detail/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 分公司部门
   * @secure
   */
  export const departments = async (orgId: number, params: { [key: string]: any } = {}) => {
    return request<SysOrgNode[]>(`/admin/sys/org/departments/${orgId}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 删除
   * @secure
   */
  export const remove = async (pid: number, id: number, params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/org/delete/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 整理数据
   * @secure
   */
  export const collate = async (params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/org/collate`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 直属库
   * @secure
   */
  export const children = async (orgId: number, params: { [key: string]: any } = {}) => {
    return request<SysOrgNode[]>(`/admin/sys/org/child/${orgId}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 直属库部门
   * @secure
   */
  export const childDepartment = async (orgId: number, params: { [key: string]: any } = {}) => {
    return request<SysOrgNode[]>(`/admin/sys/org/child/departments/${orgId}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 缓存 tree
   * @secure
   */
  export const cacheTree = async (params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/org/cache/tree`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 缓存 部门树
   * @secure
   */
  export const cacheDepartment = async (params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/org/cache/department`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 缓存 直属库树
   * @secure
   */
  export const cacheChild = async (params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/org/cache/child`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取所有数据
   * @secure
   */
  export const allOrg = async (params: { [key: string]: any } = {}) => {
    return request<SysOrg[]>(`/admin/sys/org/allOrg`, {
      method: 'GET',
      ...params,
    });
  };
}

export default AdminSysOrg;

export const treeSys = AdminSysOrg.treeSys;
export const treeQuery = AdminSysOrg.treeQuery;
export const treeDepartment = AdminSysOrg.treeDepartment;
export const treeChild = AdminSysOrg.treeChild;
export const saveTags = AdminSysOrg.saveTags;
export const setOrder = AdminSysOrg.setOrder;
export const query = AdminSysOrg.query;
export const queryChild = AdminSysOrg.queryChild;
export const paths = AdminSysOrg.paths;
export const list = AdminSysOrg.list;
export const getPosts = AdminSysOrg.getPosts;
export const getMembersAccounts = AdminSysOrg.getMembersAccounts;
export const edit = AdminSysOrg.edit;
export const create = AdminSysOrg.create;
export const batchShow = AdminSysOrg.batchShow;
export const batchSetOrder = AdminSysOrg.batchSetOrder;
export const batchHidden = AdminSysOrg.batchHidden;
export const batchEnable = AdminSysOrg.batchEnable;
export const batchDisable = AdminSysOrg.batchDisable;
export const batchDelete = AdminSysOrg.batchDelete;
export const treeUi = AdminSysOrg.treeUi;
export const treeNodeQuery = AdminSysOrg.treeNodeQuery;
export const treeNodeDepartment = AdminSysOrg.treeNodeDepartment;
export const treeNodeChild = AdminSysOrg.treeNodeChild;
export const getTagList = AdminSysOrg.getTagList;
export const getTags = AdminSysOrg.getTags;
export const staticTree = AdminSysOrg.staticTree;
export const staticDepartment = AdminSysOrg.staticDepartment;
export const staticChild = AdminSysOrg.staticChild;
export const show = AdminSysOrg.show;
export const path = AdminSysOrg.path;
export const pathInfo = AdminSysOrg.pathInfo;
export const hidden = AdminSysOrg.hidden;
export const enable = AdminSysOrg.enable;
export const disable = AdminSysOrg.disable;
export const detail = AdminSysOrg.detail;
export const departments = AdminSysOrg.departments;
export const remove = AdminSysOrg.remove;
export const collate = AdminSysOrg.collate;
export const children = AdminSysOrg.children;
export const childDepartment = AdminSysOrg.childDepartment;
export const cacheTree = AdminSysOrg.cacheTree;
export const cacheDepartment = AdminSysOrg.cacheDepartment;
export const cacheChild = AdminSysOrg.cacheChild;
export const allOrg = AdminSysOrg.allOrg;
